
(function () {

    /* =========================================================
       PSV3 ONLY
    ========================================================= */

    const path = window.location.pathname.toLowerCase();

    if (!path.includes("/products/pure-stallion-v3")) {
        return;
    }


    /* =========================================================
       CONFIG
    ========================================================= */

    const LOCK_SRC =
        "https://cdn.shopify.com/s/files/1/0867/9673/0684/files/locked_image-Gray.png?v=1775545017";


    /* =========================================================
       FREEBIES POPUP
    ========================================================= */

    document.addEventListener("DOMContentLoaded", function () {

        const popupOverlay =
            document.querySelector(".freebies-popup-overlay");

        const popupContent =
            document.querySelector(".freebies-popup-content");

        const closeBtn =
            document.querySelector(".freebies-popup-close");


        if (!popupOverlay || !popupContent || !closeBtn) {
            return;
        }


        /* Move popup directly to body */

        document.body.appendChild(popupOverlay);


        /* =====================================================
           BONUS DATA
        ===================================================== */

        const bonusData = [

            {
                title:
                    "BONUS 1: Advanced Hypertrophy Agent (Arabolic)",

                value:
                    "Valued at $99.95 — FREE",

                content: `
                    <p>
                        <strong>Advanced Hypertrophy Agent</strong>
                    </p>

                    <p>
                        A performance-focused muscle support formula
                        designed to complement your training.
                    </p>

                    <ul>
                        <li>Supports lean muscle development</li>
                        <li>Helps enhance strength output</li>
                        <li>
                            Designed to integrate into your current
                            workout routine
                        </li>
                    </ul>

                    <p>
                        <strong>
                            Built for men who train hard and expect
                            more from their physique.
                        </strong>
                    </p>
                `
            },


            {
                title:
                    "BONUS 2: $20 Gift Card",

                value:
                    "$20 Esteem Gift Card — FREE",

                content: `
                    <p>
                        Your credit toward your next order.
                    </p>

                    <ul>
                        <li>Use on any product sitewide</li>
                        <li>Stack with future promotions</li>
                        <li>
                            Ideal for re-stocking or upgrading
                            your stack
                        </li>
                    </ul>

                    <p>
                        <strong>
                            Loyalty rewarded.
                        </strong>
                    </p>
                `
            },


            {
                title:
                    "BONUS 3: Free Shipping",

                value:
                    "FREE",

                content: `
                    <ul>
                        <li>No shipping fees</li>
                        <li>Fully tracked delivery</li>
                        <li>Fast dispatch (24–48 hours)</li>
                    </ul>

                    <p>
                        <strong>
                            More value. Zero added cost.
                        </strong>
                    </p>
                `
            },


            {
                title:
                    "BONUS 4: Support Protocols (Digital Guides)",

                value:
                    "Valued at $59.85 — FREE",

                content: `
                    <p>
                        Two structured implementation guides
                        designed to maximise results:
                    </p>

                    <ul>
                        <li>
                            Natural Testosterone Support Protocol
                        </li>

                        <li>
                            Core Strengthening Protocol
                        </li>
                    </ul>

                    <p>
                        <strong>
                            Step-by-step systems. Not guesswork.
                        </strong>
                    </p>
                `
            }

        ];


        /* =====================================================
           OPEN POPUP
        ===================================================== */

        document.addEventListener("click", function (e) {

            const item =
                e.target.closest(
                    ".freebies-wrapper .item"
                );

            if (!item) return;


            const items =
                document.querySelectorAll(
                    ".freebies-wrapper .item"
                );


            const index =
                Array.from(items).indexOf(item);


            if (
                index < 0 ||
                !bonusData[index]
            ) {
                return;
            }


            e.preventDefault();
            e.stopPropagation();


            const img =
                item.querySelector("img");


            const bonus =
                bonusData[index];


            const imageSrc =
                img?.src || "";


            const imageAlt =
                img?.alt || bonus.title;


            popupContent.innerHTML = `

                <img
                    src="${imageSrc}"
                    alt="${imageAlt}"
                    class="freebies-popup-image"
                >

                <h3>
                    ${bonus.title}
                </h3>

                <div class="value">
                    ${bonus.value}
                </div>

                ${bonus.content}

            `;


            popupOverlay.classList.add("active");

            document.body.style.overflow = "hidden";

        });


        /* =====================================================
           CLOSE BUTTON
        ===================================================== */

        closeBtn.addEventListener("click", function () {

            popupOverlay.classList.remove("active");

            document.body.style.overflow = "";

        });


        /* =====================================================
           CLOSE BY CLICKING OUTSIDE
        ===================================================== */

        popupOverlay.addEventListener(
            "click",
            function (e) {

                if (e.target === popupOverlay) {

                    popupOverlay.classList.remove(
                        "active"
                    );

                    document.body.style.overflow = "";

                }

            }
        );

    });


    /* =========================================================
       HIDE STICKY CART
    ========================================================= */

    function hideStickyCart() {

        const els =
            document.querySelectorAll(
                ".desktopStickyCartContainar___3nN72, " +
                ".mu_sticky_descktop, " +
                ".mu_sticky_visible"
            );


        els.forEach(function (el) {

            el.style.opacity = "0";

            el.style.pointerEvents = "none";

            el.classList.remove(
                "mu_sticky_visible"
            );

        });

    }


    const stickyInterval =
        setInterval(
            hideStickyCart,
            100
        );


    setTimeout(function () {

        clearInterval(stickyInterval);

    }, 30000);


    /* =========================================================
       PSV3 BUNDLE / FREEBIE LOCK SYSTEM
    ========================================================= */

    document.addEventListener(
        "DOMContentLoaded",
        function () {

            const freebiesWrapper =
                document.querySelector(
                    ".freebies-wrapper"
                );


            if (!freebiesWrapper) {
                return;
            }


            /* =====================================================
               PSV3 BUNDLE SELECTORS

               3 Bottles = #pumper__label_1
               2 Bottles = #pumper__label_2
               1 Bottle  = #pumper__label_3
            ===================================================== */

            function getBundleNumber(element) {

                if (!element) {
                    return null;
                }


                if (
                    element.closest(
                        "#pumper__label_1"
                    )
                ) {
                    return 1;
                }


                if (
                    element.closest(
                        "#pumper__label_2"
                    )
                ) {
                    return 2;
                }


                if (
                    element.closest(
                        "#pumper__label_3"
                    )
                ) {
                    return 3;
                }


                return null;
            }


            /* =====================================================
               GET FREEBIE ITEM
            ===================================================== */

            function getItem(n) {

                const item =
                    document.querySelector(
                        `.freebies-wrapper > .item:nth-child(${n})`
                    );


                if (!item) {
                    return {};
                }


                const img =
                    item.querySelector("img");

                const title =
                    item.querySelector(".item-title");

                const tag =
                    item.querySelector(".tag");


                /* Save original values */

                if (
                    img &&
                    !img.dataset.original
                ) {

                    img.dataset.original =
                        img.src;

                }


                if (
                    title &&
                    !title.dataset.original
                ) {

                    title.dataset.original =
                        title.innerHTML;

                }


                if (
                    tag &&
                    !tag.dataset.original
                ) {

                    tag.dataset.original =
                        tag.innerHTML;

                }


                return {

                    img: img,
                    title: title,
                    tag: tag

                };

            }


            /* =====================================================
               FREEBIE REFERENCES
            ===================================================== */

            let item1 = getItem(1);
            let item2 = getItem(2);
            let item3 = getItem(3);
            let item4 = getItem(4);


            /* =====================================================
               REFRESH ITEMS
            ===================================================== */

            function refreshItems() {

                item1 = getItem(1);
                item2 = getItem(2);
                item3 = getItem(3);
                item4 = getItem(4);

            }


            /* =====================================================
               LOCK ITEM
            ===================================================== */

            function lock(item, text) {

                if (!item) {
                    return;
                }


                if (item.img) {

                    if (
                        !item.img.dataset.original
                    ) {

                        item.img.dataset.original =
                            item.img.src;

                    }


                    item.img.src =
                        LOCK_SRC;

                }


                if (item.title) {

                    item.title.innerHTML =
                        `Unlock<br>${text}`;

                }


                if (item.tag) {

                    item.tag.innerHTML =
                        `Unlock<br>${text}`;

                }

            }


            /* =====================================================
               UNLOCK ITEM
            ===================================================== */

            function unlock(item) {

                if (!item) {
                    return;
                }


                if (
                    item.img &&
                    item.img.dataset.original
                ) {

                    item.img.src =
                        item.img.dataset.original;

                }


                if (
                    item.title &&
                    item.title.dataset.original
                ) {

                    item.title.innerHTML =
                        item.title.dataset.original;

                }


                if (
                    item.tag &&
                    item.tag.dataset.original
                ) {

                    item.tag.innerHTML =
                        item.tag.dataset.original;

                }

            }


            /* =====================================================
               BONUS TEXT
            ===================================================== */

            function updateBonus(type) {

                const el =
                    document.querySelector(
                        ".bundleBonusText"
                    );


                if (!el) {
                    return;
                }


                /* ===============================================
                   3 BOTTLES
                =============================================== */

                if (type === "all") {

                    el.innerHTML =
                        `<strong>All bonuses unlocked</strong><br>` +
                        `🎉 you're getting ` +
                        `<b>$189.75 in free gifts</b>`;

                }


                /* ===============================================
                   2 BOTTLES
                =============================================== */

                if (type === "mid") {

                    el.innerHTML =
                        `Upgrade to <b>3 bottles</b> to unlock your ` +
                        `<b>FREE Lean Muscle Builder ` +
                        `($99.95 value)</b>`;

                }


                /* ===============================================
                   1 BOTTLE
                =============================================== */

                if (type === "low") {

                    el.innerHTML =
                        `You're <b>1 bottle away</b> from unlocking ` +
                        `<b>$189.75 in free bonuses</b>`;

                }

            }


            /* =====================================================
               FREE SHIPPING
            ===================================================== */

            function updateShipping(type) {

                const shippingEl =
                    document.querySelector(
                        ".freeShippingText"
                    );


                if (!shippingEl) {
                    return;
                }


                if (type === "free") {

                    shippingEl.innerHTML =
                        "<strong>FREE SHIPPING</strong>";

                    shippingEl.classList.add(
                        "unlocked"
                    );

                    shippingEl.classList.remove(
                        "locked"
                    );

                } else {

                    shippingEl.innerHTML =
                        "FREE SHIPPING";

                    shippingEl.classList.remove(
                        "unlocked"
                    );

                    shippingEl.classList.add(
                        "locked"
                    );

                }

            }


            /* =====================================================
               APPLY BUNDLE
            ===================================================== */

            function apply(bundleNumber) {

                refreshItems();


                /* ===============================================
                   3 BOTTLES
                   
                   ALL GIFTS UNLOCKED
                =============================================== */

                if (bundleNumber === 1) {

                    unlock(item1);
                    unlock(item2);
                    unlock(item3);
                    unlock(item4);

                    updateBonus("all");

                    updateShipping("free");

                    return;

                }


                /* ===============================================
                   2 BOTTLES
                   
                   ITEM 1 LOCKED
                =============================================== */

                if (bundleNumber === 2) {

                    lock(
                        item1,
                        "3+ Bottles"
                    );

                    unlock(item2);
                    unlock(item3);
                    unlock(item4);

                    updateBonus("mid");

                    updateShipping("free");

                    return;

                }


                /* ===============================================
                   1 BOTTLE
                   
                   ITEMS 1 + 2 LOCKED
                =============================================== */

                if (bundleNumber === 3) {

                    lock(
                        item1,
                        "3+ Bottles"
                    );

                    lock(
                        item2,
                        "2+ Bottles"
                    );

                    lock(
                        item3,
                        "2+Bottles"
                    );
                    unlock(item4);

                    updateBonus("low");

                    updateShipping("free");

                    return;

                }

            }


            /* =====================================================
               BUNDLE CLICK EVENT

               Uses event delegation because PSV3 is generated
               dynamically by the bundle app.
            ===================================================== */

            document.addEventListener(
                "click",
                function (event) {

                    const bundleNumber =
                        getBundleNumber(
                            event.target
                        );


                    if (!bundleNumber) {
                        return;
                    }


                    /*
                     * Allow the bundle app to update its
                     * selected state first.
                     */

                    setTimeout(function () {

                        apply(bundleNumber);

                    }, 50);

                }
            );


            /* =====================================================
               DEFAULT STATE
               
               PSV3 loads on 3 BOTTLES
               
               ALL GIFTS UNLOCKED
            ===================================================== */

            apply(1);


            /* =====================================================
               WATCH FOR FREEBIE REPLACEMENT
            ===================================================== */

            const observer =
                new MutationObserver(
                    function () {

                        refreshItems();

                    }
                );


            observer.observe(
                freebiesWrapper,
                {
                    childList: true,
                    subtree: true
                }
            );

        }
    );

})();


(function () {

    if (
        !window.location.pathname
            .toLowerCase()
            .includes("/products/pure-stallion-v3")
    ) {
        return;
    }

    function updatePriceColor() {

        const price = document.querySelector(
            "#ecom-lpdvuubwtd > div.core__blocks > div > div.ecom-block.ecom-core.core__block.ecom-d6214k1tj > div > div > div > div.ecom-product-single__price-container-grid > div > div.ecom-product-single__price--regular"
        );

        if (price) {
            price.style.color = "#cc2839";
        }
    }

    updatePriceColor();

    const observer = new MutationObserver(function () {
        updatePriceColor();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();